import { c as _c } from "react/compiler-runtime";
import { FlagSolid, HomeSolid, MapPinSolid, PinSolid } from '@byway/icons';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { shortDayShortMonth } from 'utils/DateFormats';
import { NightsAdjuster } from '~/components/Journey/JourneyMap/NightsAdjuster';
import { usePlaygroundDateType } from '~/stores/playgroundStore';
import type { StayTransformed } from '~/types/JourneyItem.types';
import styles from './PlaygroundTimeline.module.css';
import type { Item, PlaygroundTimelineProps } from './PlaygroundTimeline.types';
const PlaygroundTimeline = t0 => {
  const $ = _c(62);
  const {
    journey,
    skeletonTripId,
    mode: t1,
    isDisabled: t2
  } = t0;
  t1 === undefined ? "exact-dates" : t1;
  const isDisabled = t2 === undefined ? false : t2;
  const t = useTranslations("journey");
  const {
    startDate,
    endDate
  } = journey.details;
  const {
    items
  } = journey;
  const dateType = usePlaygroundDateType();
  const first = items[0];
  const last = items[items.length - 1];
  const t3 = first.type === "Journey" ? first.origin : first.title || "Unknown";
  let t4;
  if ($[0] !== first.id || $[1] !== t3) {
    t4 = {
      title: t3,
      id: first.id
    };
    $[0] = first.id;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const origin = t4;
  const t5 = last.type === "Journey" ? last.destination : last.title || "Unknown";
  let t6;
  if ($[3] !== last.id || $[4] !== t5) {
    t6 = {
      title: t5,
      id: last.id
    };
    $[3] = last.id;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const destination = t6;
  const isRoundTrip = origin.id === destination.id;
  const stayAtStart = first.type === "Stay" ? first as StayTransformed : null;
  const stayAtEnd = last.type === "Stay" ? last as StayTransformed : null;
  let t10;
  let t11;
  let t12;
  let t13;
  let t7;
  let t8;
  let t9;
  if ($[6] !== dateType || $[7] !== isDisabled || $[8] !== items || $[9] !== journey || $[10] !== origin || $[11] !== skeletonTripId || $[12] !== startDate || $[13] !== stayAtStart || $[14] !== t) {
    let t14;
    if ($[22] !== items.length) {
      t14 = (item, index) => {
        if (index === 0 || index === items.length - 1) {
          return false;
        }
        return item.type === "Stay" && item.nights && item.nights > 0;
      };
      $[22] = items.length;
      $[23] = t14;
    } else {
      t14 = $[23];
    }
    const overview = items.filter(t14);
    t12 = styles.container;
    if ($[24] !== dateType || $[25] !== startDate) {
      t13 = dateType !== "nights" && <p className={styles.dateText}>{shortDayShortMonth(startDate)}</p>;
      $[24] = dateType;
      $[25] = startDate;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    t10 = styles.timelineContainer;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div className={styles.timelineLine} />;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    t7 = styles.timelineList;
    if ($[28] !== journey || $[29] !== origin || $[30] !== skeletonTripId || $[31] !== stayAtStart || $[32] !== t) {
      t8 = origin && <li key="timeline-start" className={styles.timelineItem}><div className={clsx(styles.timelineIconCircle, styles.originCircle)}><HomeSolid color="white" size="small" decorative={true} /></div><div className={styles.itemTitle} data-test-id="timeline-item-title">{origin.title}</div><div className={styles.itemDetailsContainer}>{journey && <NightsAdjuster key={`nights-start-${stayAtStart?.id || "none"}`} item={stayAtStart} journeyId={journey.uniqueId} skeletonTripId={skeletonTripId} atStart={true} atEnd={false} placeName={origin.title} />}{!stayAtStart && <span className={styles.startEndText}>{t("map_start")}</span>}</div></li>;
      $[28] = journey;
      $[29] = origin;
      $[30] = skeletonTripId;
      $[31] = stayAtStart;
      $[32] = t;
      $[33] = t8;
    } else {
      t8 = $[33];
    }
    let t15;
    if ($[34] !== isDisabled || $[35] !== journey || $[36] !== skeletonTripId) {
      t15 = item_0 => <li key={`timeline-${item_0.id}`} className={styles.timelineItem}><div className={clsx(styles.timelineIconCircle, {
          [styles.stayCircle]: false,
          [styles.nonEssenceCircle]: true
        })}>{false ? <PinSolid color="white" size="small" decorative={true} /> : <MapPinSolid color="white" size="small" decorative={true} />}</div><div className={styles.itemTitle} data-test-id="timeline-item-title">{item_0.type === "Journey" ? `${item_0.origin} to ${item_0.destination}` : item_0.title || "Unknown"}</div><div className={styles.itemDetailsContainer}>{journey && item_0.type === "Stay" && <NightsAdjuster item={item_0} journeyId={journey.uniqueId} skeletonTripId={skeletonTripId} isDisabled={isDisabled} />}</div></li>;
      $[34] = isDisabled;
      $[35] = journey;
      $[36] = skeletonTripId;
      $[37] = t15;
    } else {
      t15 = $[37];
    }
    t9 = overview.map(t15);
    $[6] = dateType;
    $[7] = isDisabled;
    $[8] = items;
    $[9] = journey;
    $[10] = origin;
    $[11] = skeletonTripId;
    $[12] = startDate;
    $[13] = stayAtStart;
    $[14] = t;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t10 = $[15];
    t11 = $[16];
    t12 = $[17];
    t13 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t14;
  if ($[38] !== destination || $[39] !== isRoundTrip || $[40] !== journey || $[41] !== skeletonTripId || $[42] !== stayAtEnd || $[43] !== t) {
    t14 = destination && <li key="timeline-end" className={styles.timelineItem}><div className={clsx(styles.timelineIconCircle, styles.endCircle)}>{isRoundTrip ? <HomeSolid color="white" size="small" decorative={true} /> : <FlagSolid color="white" size="small" decorative={true} />}</div><div className={styles.itemTitle} data-test-id="timeline-item-title">{destination.title}</div><div className={styles.itemDetailsContainer}>{journey && <NightsAdjuster key={`nights-end-${stayAtEnd?.id || "none"}`} item={stayAtEnd} journeyId={journey.uniqueId} skeletonTripId={skeletonTripId} atStart={false} atEnd={true} placeName={destination.title} />}{!stayAtEnd && <span className={styles.startEndText}>{t("map_end")}</span>}</div></li>;
    $[38] = destination;
    $[39] = isRoundTrip;
    $[40] = journey;
    $[41] = skeletonTripId;
    $[42] = stayAtEnd;
    $[43] = t;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== t14 || $[46] !== t7 || $[47] !== t8 || $[48] !== t9) {
    t15 = <ol className={t7}>{t8}{t9}{t14}</ol>;
    $[45] = t14;
    $[46] = t7;
    $[47] = t8;
    $[48] = t9;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  let t16;
  if ($[50] !== t10 || $[51] !== t11 || $[52] !== t15) {
    t16 = <div className={t10}>{t11}{t15}</div>;
    $[50] = t10;
    $[51] = t11;
    $[52] = t15;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  let t17;
  if ($[54] !== dateType || $[55] !== endDate) {
    t17 = dateType !== "nights" && <p className={styles.dateText}>{shortDayShortMonth(endDate)}</p>;
    $[54] = dateType;
    $[55] = endDate;
    $[56] = t17;
  } else {
    t17 = $[56];
  }
  let t18;
  if ($[57] !== t12 || $[58] !== t13 || $[59] !== t16 || $[60] !== t17) {
    t18 = <div className={t12}>{t13}{t16}{t17}</div>;
    $[57] = t12;
    $[58] = t13;
    $[59] = t16;
    $[60] = t17;
    $[61] = t18;
  } else {
    t18 = $[61];
  }
  return t18;
};
export { PlaygroundTimeline };